import { render, staticRenderFns } from "./progress-color.vue?vue&type=template&id=39dea291"
import script from "./progress-color.vue?vue&type=script&lang=js"
export * from "./progress-color.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports